// FOOTER component
//************************************************************************************************************************** 
//DEPENDENCIES
//IMPORTING BOOTSTRAP

import $ from 'jquery'
import Popper from 'popper.js'
//IMPORTING REACT
import React from 'react'
//IMPORTING GATSBY
import {StaticQuery, graphql, Link} from 'gatsby'
//IMPORTING CUSTOM CSS file
import '../styles/footer.css'
//************************************************************************************************************************** 
//**************************************************************************************************************************
export default () => (
    <StaticQuery
//******DB QUERY
        query={graphql`
                query {
                    footer: allButterPage(filter: { slug: { eq: "footer" } }) {
                    edges {
                        node {
                            site_links {
                                label
                                url
                            }
                            social_media_links {
                                icon 
                                url 
                                label
                            }
                            agency_name
                            address
                            email
                            phone_number
                            footer_highlights {
                                title
                                description
                                link
                            }
                            agency_seals {
                                agency_seal
                            }
                            logo
                        }
                    }
                }
                allButterCollection(filter: { id: { eq: "internal_navbar_links" } }) {
                edges {
                    node {
                        id
                        value {
                            child_items {
                                label
                                url
                            },
                            url,
                            label,
                        }
                    }
                }
            }}
        `}
//************************************************************************************************************************** 
//**************************************************************************************************************************     
//*******SOME NOTES! :) - KW
//
//*******CLASSES & IDs 
//***********mine: camelCase
//***********Bootstrap 4: dashed -
//
//*******COMMENTS/ELEMENT GROUPING
//***********my START comments are immediately preceding the corresponding tag
//***********my END comments are immediately following the corresponding closing tag 
//
//*******FRAMEWORK OUTLINE
//***********ROW 1
//***************1.1 NAVIGATION
//********************1.1.1 Home Link
//********************1.1.2 About Link
//********************1.1.3 Report Link
//********************1.1.4 Alerts & Advisories Link
//********************1.1.5 Public Data Breaches Link
//********************1.1.6 Threat Profiles Link
//********************1.1.7 Learn Link
//********************1.1.8 Outreach Link
//********************1.1.8 Events Link
//********************1.1.8 Presentations Link
//********************1.1.8 Membership Link
//********************1.1.8 Contact Link
//***************1.2 MISSION STATEMENT
//***************1.3 RESOURCES
//***************1.4 SOCIAL MEDIA LINKS
//***********ROW 2
//***************2.1 AGENCY NAME
//***************2.2 ADDRESS
//***************2.3 EMAIL 
//
//**************************************************************************************************************************
//************************************************************************************************************************** 
        render={data => (
            <div>
    
{/**************IMPORTING BOOTSTRAP STYLESHEET*/}     
                <link href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk" crossorigin="anonymous"></link>
                
{/**************START FOOTER*/}               
                <div class="container-fluid" id='footerContainer'>
                    <div >
{/**********************START ROW 1*/}    
                        <div class='row' >                            
                            <div class="bodyText footerText footerLogo" id='borderTop'>
                                <a href={data.allButterCollection.edges[0].node.value[0].url}><img class='navbar-brand inline' id='altLogo' alt="NJCCIC alternative logo" loading="lazy" src={data.footer.edges[0].node.agency_seals[0].agency_seal}/></a>
                                {/*<p class='contact inline'>{data.footer.edges[0].node.agency_name}</p>*/}       
                            </div> 
                            <div class="bodyText footerText footerName" id='borderTop'>
                                <p class='contact inline breakRight' id="footerLogoText">{data.footer.edges[0].node.agency_name}</p>  
                                <p class='contact breakRight breakLeft inline'>{data.footer.edges[0].node.address}</p>
                                <p class='contact breakLeft inline'>{data.footer.edges[0].node.email}</p>
                            </div>
                        </div>
                        
                        <div class="row">
{/**************************START COLUMN 1.1: MISSION STATEMENT*/}
                            <div class='col-10 offset-1 col-lg-5 offset-lg-0 bodyText footerText columnPadding' id='firstColumn'>
                                
                                <p class='footerHeaders'>{data.footer.edges[0].node.footer_highlights[0].title}</p>
                                <div class='footerColumn'>
                                    <p>{data.footer.edges[0].node.footer_highlights[0].description}</p>
                                    <img class='navbar-brand inline' id='agencySeals' alt="Agency Seals of State of NJ, NJOHSP and NJCCIC" loading="lazy" src={data.footer.edges[0].node.agency_seals[1].agency_seal}/>
                                    
                                        <p class='footerHeaders inline'>{data.footer.edges[0].node.site_links[13].label}: </p>
                                        <a href={data.footer.edges[0].node.social_media_links[0].url} target="_blank" rel="noopener"><img class='socialIcons' alt="Social Media Twitter Icon" loading="lazy" src={data.footer.edges[0].node.social_media_links[0].icon} /></a>
                                        <a href={data.footer.edges[0].node.social_media_links[1].url} target="_blank" rel="noopener"><img class='socialIcons' alt="Social Media Facebook Icon" loading="lazy" src={data.footer.edges[0].node.social_media_links[1].icon}/></a>
										<a href={data.footer.edges[0].node.social_media_links[2].url} target="_blank" rel="noopener"><img class='socialIcons' alt="Social Media Instagram Icon" loading="lazy" src={data.footer.edges[0].node.social_media_links[2].icon} /></a>
                                        <a href={data.footer.edges[0].node.social_media_links[3].url} target="_blank" rel="noopener"><img class='socialIcons' alt="Social Media RSS Feed Icon" loading="lazy" src={data.footer.edges[0].node.social_media_links[3].icon}/></a>
                                     	<p>View our Privacy Policy <a href="https://www.nj.gov/nj/privacy.html" class="footerLinks">here</a>.</p>
				     					<p>View our Site Index <a href="https://www.cyber.nj.gov/siteindex/" class="footerLinks" style={{color: "#57A0D3;"}}>here</a>.</p>
                                </div>
                            </div>
{/**************************END COLUMN 1.1*/}
{/****************************col-10 offset-1 col-lg-4 offset-lg-0
*********************************************col-10 col-md-5 offset-md-0 col-lg-3 offset-lg-0                               */}  
{/**************************START COLUMN 1.2: NAVIGATION*/}
                            <div class='col-5 offset-1 col-lg-3 offset-lg-0 bodyText footerTextAlt columnPadding' id='footerMenu'>
                                <p class='footerHeaders'>{data.footer.edges[0].node.site_links[10].label}</p>
                                <div class='footerColumn'>
                                    <ul class='footerNavList'> 
{/**************************************1.1.1 - HOME*/}
                                        <li class="pointer" title='Home'>
                                            <a href={data.allButterCollection.edges[0].node.value[0].url} class='menuOption'>Home</a>
                                        </li>
{/**************************************1.1.2 - REPORTING INFORMATION*/}                                        
                                        <li class='pointer' title='Report'>
                                            <a class='menuOption' href={data.allButterCollection.edges[0].node.value[4].url}>Report</a>  
                                        </li>
{/**************************************1.1.3 - ABOUT*/}
                                        <li class='pointer' title='About'>
                                            <a href={data.allButterCollection.edges[0].node.value[5].url} class='menuOption'>About</a>
                                        </li>
{/**************************************1.1.4 - ALERTS & ADVISORIES*/}
                                        <li class='pointer' title='Alerts & Advisories'>
                                            <a href={data.allButterCollection.edges[0].node.value[7].url}>Alerts & Advisories</a>
                                        </li>                                        
{/**************************************1.1.5 - DATA BREACHES*/}
                                        <li class='pointer' title='Public Data Breaches'>
                                            <a href={data.allButterCollection.edges[0].node.value[8].url}>Public Data Breaches</a>
                                        </li>
{/**************************************1.1.6 - THREAT ANALYSIS REPORTS*/}  
                                        <li class='pointer' title='Threat Analysis Reports'>
                                            <a href={data.allButterCollection.edges[0].node.value[9].url}>Threat Analysis Reports</a>
                                        </li>
{/**************************************1.1.7 - THREAT PROFILES*/}  
                                        <li class='pointer' title='Threat Profiles'>
                                            <a href={data.allButterCollection.edges[0].node.value[10].url}>Threat Profiles</a>
                                        </li>
{/**************************************1.1.8 - ELECTION SECURITY*/}  
                                        <li class='pointer' title='Election Security'>
                                            <a href={data.allButterCollection.edges[0].node.value[40].url}>Election Security</a>
                                        </li>   
{/**************************************1.1.9 - THIS IS SECURITY SERIES*/}  
                                        <li class='pointer' title='This is Security Series'>
                                            <a href={data.allButterCollection.edges[0].node.value[20].url}>This is Security Series</a>
                                        </li> 
                                    </ul>
                                </div>
                            </div>
                            
                            <div class='col-5 col-lg-3 bodyText footerText columnPadding' id='footerMenu'>
                                <p class='footerHeaders' id="fade">{data.footer.edges[0].node.site_links[10].label}</p>
                                <div class='footerColumn'>
                                    <ul class='footerNavList'>                                         
{/**************************************1.1.10 - CYBER BEST PRACTICES*/}
                                        <li class='pointer' title='Cybersecurity Best Practices'>
                                            <a href={data.allButterCollection.edges[0].node.value[22].url}>Cybersecurity Best Practices</a>
                                        </li>     
                                        
{/**************************************1.1.11 - BUSINESS & GOV RESOURCES*/}
                                         <li class='pointer' title='Business & Government Resources'>
                                            <a href={data.allButterCollection.edges[0].node.value[23].url}>Business & Government Resources</a>
                                        </li>
{/**************************************1.1.12 - E-LEARNING*/}
                                        <li class='pointer' title='E-Learnin'>
                                            <a href={data.allButterCollection.edges[0].node.value[21].url}>E-Learning</a>
                                        </li>
{/**************************************1.1.14 - TECHNICAL GUIDES*/}
                                        <li class='pointer' title='Technical Guides'>
                                            <a href={data.allButterCollection.edges[0].node.value[26].url}>Technical Guides</a>
                                        </li> 
{/**************************************1.1.15 - Be Sure to Secure*/}
                                        <li class='pointer' title='Be Sure to Secure'>
                                            <a href={data.allButterCollection.edges[0].node.value[27].url}>Be Sure to Secure</a>
                                        </li>   
{/**************************************1.1.16 - PRESENTATIONS*/}
                                        <li class='pointer' title='Presentations'>
                                            <a href={data.allButterCollection.edges[0].node.value[28].url}>Presentations</a>
                                        </li>
{/**************************************1.1.17 - PARTNER RESOURCES*/}
                                        <li class='pointer' title='Partner Resources'>
                                            <a href={data.allButterCollection.edges[0].node.value[29].url}>Partner Resources</a>
                                        </li>
{/**************************************1.1.19 - CYBER AWARENESS POSTER CONTEST*/}
                                        <li class='pointer' title='Membership'>
                                            <a href={data.allButterCollection.edges[0].node.value[36].url}>Membership</a>
                                        </li>
{/**************************************1.1.20 - GIRLS GO CYBERSTART*/}
                                        <li class='pointer' title='Contact'>
                                            <a href={data.allButterCollection.edges[0].node.value[37].url}>Contact</a>
                                        </li>
										<li class='pointer' title='Member Portal Login'>
                                            <a  style={{color: "blue"}} href="https://members.cyber.nj.gov/">Member Portal Login</a>
                                        </li>
                                    </ul>
                                                                    
                                </div>
                            </div>
                        </div>
{/**********************START ROW 2   
                        <div class='row' >                            
                            <div class="col-10 offset-1 bodyText footerText baseFooterText" id='borderTop'>                              
                                <p class='contact breakRight breakLeft inline'>{data.footer.edges[0].node.address}</p>
                                <p class='contact breakRight breakLeft inline'>{data.footer.edges[0].node.email}</p>
                            </div>
                        </div>*/} 

                    
{/**********************END ROW 2*/}
                    </div>
                </div>     
{/**************END FOOTER*/}  
                <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/js/bootstrap.min.js" integrity="sha384-OgVRvuATP1z7JjHLkuOU7Xw704+h835Lr+6QL9UvYjZE3Ipu6Tp75j7Bh/kR0JKI" crossorigin="anonymous"></script>
            </div>
        )}
    />
)
//************************************************************************************************************************** 
//************************************************************************************************************************** 
